import {UrlApi} from "../../../services/apirest"

export async function verificarCuit(dataCliente, setDataCliente, setErrorDialog) {
  const cuit=dataCliente.cuit
  // console.log("CUIT QUE LLEGA A LA FUNCION " , cuit)

  //1- pregunto si hay un cuit
  const hayCuit = /[1-9]/.test(cuit);
  // console.log(hayCuit);
  if (hayCuit) {
    //si hay cuit, valido que ese cuit sea correcto
    const validado = validarCuit(cuit);
    // console.log("EL CUIT ESTA VALIDADO: ", validado);
    if (validado) {
      //si es correcto, busco que no exista
      const coincidencias = await existeCuit(cuit);
      if (coincidencias.length > 0) {
        setDataCliente({ ...dataCliente, cuit: "" });
        // alert("El cuit ya fue ingresado.")
        setErrorDialog(true)
      }
    }else{
      alert("CUIT INVÁLIDO.")
      setDataCliente({ ...dataCliente, cuit: "" });
    }
  }
}


export async function verificarDni(dataCliente, setDataCliente, setErrorDialog) {
  const dni= dataCliente.cuit;
  const hayDni = /[1-9]/.test(dni);
  
  if (hayDni) {
    const coincidencias = await existeCuit(dni);
    if (coincidencias.length > 0) {
      setDataCliente({ ...dataCliente, cuit: "" });
      setErrorDialog(true)
    }
  }
}

export function validarCuit(cuit) {
  if (cuit.length > 0) {
    const replace = cuit.replace(/-/g, ""); // remplaza los - y los quita
    if (replace.length !== 11) {
    } else {
      let acumulado = 0;
      let digitos = replace.split("");
      let digito = parseInt(digitos.pop());
      for (let i = 0; i < digitos.length; i++) {
        acumulado += digitos[9 - i] * (2 + (i % 6));
      }
      let verif = 11 - (acumulado % 11);
      if (verif === 11) {
        verif = 0;
      } else if (verif === 10) {
        verif = 9;
      }
      if (digito !== verif) {
        return false;
      } else {
        return true;
      }
    }
  }
}

export async function existeCuit(cuit) {
  const response = await fetch(UrlApi + "/clientes/existecuit/" + cuit);
  const coincidencias = await response.json();
  return coincidencias;
}

